import { Shield, TrendingDown, Users } from 'lucide-react';
import { trackSimulateClick } from '@/lib/analytics';

export function Hero() {
  return (
    <section className="relative min-h-[90vh] flex items-center bg-white border border-navy-50/80 overflow-hidden shadow-[0_30px_60px_rgba(30,32,68,0.09)]">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-40">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231E2044' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}
        />
      </div>

      {/* Gradient Orb */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-gold-500/15 rounded-full blur-[90px]"></div>
      <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-gold-600/10 rounded-full blur-[70px]"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-gold-500/10 border border-gold-500/20 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 bg-gold-400 rounded-full animate-pulse"></span>
            <span className="text-gold-300 text-sm font-medium">Eficiência Tributária para Holdings Patrimoniais</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-navy-950 mb-6 tracking-tight leading-tight">
            Crie uma Holding Patrimonial,
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-300">
              {' '}ganhe eficiência tributária
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-navy-600 mb-8 max-w-2xl leading-relaxed">
            Nós cuidamos de todo o processo: desde a abertura da empresa até a integração dos imóveis e os serviços contábeis. E o melhor? Você não precisa pagar caro por isso.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="#calculadora"
              onClick={() => trackSimulateClick('hero')}
              className="inline-flex items-center justify-center rounded-lg bg-gold-500 px-8 py-4 text-base font-semibold text-white shadow-[0_20px_40px_rgba(212,160,23,0.35)] transition"
            >
              Simular Economia Tributária
            </a>
            <a
              href="#servicos"
              className="inline-flex items-center justify-center rounded-lg border border-navy-200 px-8 py-4 text-base font-semibold text-navy-900 hover:bg-navy-50 transition-colors"
            >
              Benefícios da Holding
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-8 text-navy-600">
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-gold-400" />
              <span className="text-sm">Conformidade Fiscal Garantida</span>
            </div>
            <div className="flex items-center gap-2">
              <TrendingDown className="w-5 h-5 text-gold-400" />
              <span className="text-sm">Redução de Carga Tributária</span>
            </div>
            <div className="flex items-center gap-2">
              <Users className="w-5 h-5 text-gold-400" />
              <span className="text-sm">Mais lucro para famílias que crescem</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-navy-50/70 to-transparent"></div>
    </section>
  );
}
